import { useQuery, UseQueryResult } from 'react-query';
import { GlobalService } from '../types/GlobalService';

const get = async (apiUrl: string, globalServiceId: string): Promise<GlobalService> => {
  if (!apiUrl || !globalServiceId) {
    throw new Error('Required properties are not set');
  }

  const response: Response = await fetch(`${apiUrl}/global-service/${globalServiceId}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch global service');
  }

  return (await response.json()) as GlobalService;
};

interface UseFetchGlobalServiceProps {
  globalServiceId?: string;
}

export const useFetchGlobalService = ({
  globalServiceId,
}: UseFetchGlobalServiceProps): UseQueryResult<GlobalService> => {
  const apiUrl = window.BENCH?.auApi?.FIND_GLOBAL_SERVICES_API_URL || '';

  return useQuery({
    queryKey: ['getGlobalService', globalServiceId],
    enabled: !!globalServiceId,
    queryFn: () => {
      if (!globalServiceId) {
        throw new Error('globalServiceId is required');
      }
      return get(apiUrl, globalServiceId);
    },
  });
};
